/* eslint-disable react-hooks/exhaustive-deps */

import { Box, ThemeProvider, createTheme } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import HouseholdGoods from './householdGoods.component';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';

import {
  getAddress,
  getAuthClientPolicies,
  getAuthDateSummary,
  getAuthorizationSummary,
  getCommunicationInfo,
  getDepartureAddress,
  getDestinationAddress,
  getEmployeeInfo,
  getFamilyMembers,
  getFamilyPets,
  getFinanceAndTax,
  getServices,
  getTeam,
  getUserSettings,
  setAuthId,
  setLoadingComplete
} from '../../store/actions/authorizations.actions';

import { getHhgSegments, getHhgVehicles, postHhgSegment } from 'modules/authorizations/store/actions/houseHoldGoods.actions';

import { getVendorContacts, getVendors } from 'modules/authorizations/store/actions/dataManagement.actions';

import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import {
  fetchAuthDetails,
  fetchAuthHouseholdGoodsDetails,
  fetchEnumerations,
  fetchVendors
} from 'modules/authorizations/utils/fetchDataDetailsService';
import { showToast } from 'modules/layout/layout.actions';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { getEmailTemplateSummaries } from 'modules/emailTemplates/store/emailTemplate.actions';
import { getClientDetails, setClientId } from 'modules/clients/clients.actions';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});
const SHORT_TERM_ASSIGNMENT_MOVE_TYPE_ID = '83BBE794-E171-403E-B545-23508B017354';


const HouseholdGoodsView = props => {
  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const { enumerations } = props;

  const details = props.authorizationDetails ? props.authorizationDetails[props.match.params.id] : null;
  const vendorDetails = props.vendors ? props.vendors : null;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      const id = props.match.params.id;

      window.scrollTo(0, 0);
      props.setAuthId(id);
      setIsLoading(true);

      await fetchAuthDetails(details, id, props);
      await fetchVendors(props?.vendors, props);
      await fetchAuthHouseholdGoodsDetails(details, id, props);

      await fetchEnumerations(props);
      if (!props.templates || props.templates.isLoaded === false) {
        await props.getEmailTemplateSummaries();
      }
      setIsLoading(false);
    }

    fetchData();
  }, []);

  const canReadHHG = hasPermission(Permissions.File.HHG.Read);
  const canEditHHG = hasPermission(Permissions.File.HHG.Edit);
  const isShortTermAssignment = details?.authorizationDetails?.moveTypeId?.toUpperCase() === SHORT_TERM_ASSIGNMENT_MOVE_TYPE_ID;
  const staEditAccess = hasPermission(Permissions.File.STA.Edit);

  if (!canReadHHG) {
    props.history.push('/');
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box>
        {!isLoading && enumerations.allEnums?.provinces && details?.hhgSegments && props.clientsInfo && (
          <HouseholdGoods
            details={details}
            vendors={vendorDetails}
            clientInfo={props.clientsInfo[details.authorizationDetails.clientId]}
            id={props.match.params.id}
            history={props.history}
            location={props.location}
            enumerations={props.enumerations.allEnums || []}
            emailTemplates={props.templates ? props.templates.emailTemplates : []}
            isReadOnly={isShortTermAssignment ? !staEditAccess : !canEditHHG}
          />
        )}
        {(isLoading || !enumerations.allEnums?.provinces || !props.clientsInfo) && <FullscreenSpinner />}
      </Box>
    </ThemeProvider>
  );
};

HouseholdGoodsView.propTypes = {
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { authorizationDetails, isLoading, vendors, vendorContacts } = state.authorizations;
  const { unmappedClients, clientsInfo } = state.clients;
  const enumerations = state.enumerations;
  const templates = state.templates;

  return {
    authorizationDetails,
    unmappedClients,
    isLoading,
    vendors,
    vendorContacts,
    enumerations,
    templates,
    clientsInfo
  };
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {
    getAuthorizationSummary,
    getEmployeeInfo,
    getCommunicationInfo,
    getAuthClientPolicies,
    setAuthId,
    setLoadingComplete,
    getAuthDateSummary,
    getDepartureAddress,
    getDestinationAddress,
    getTeam,
    getServices,
    getUserSettings,
    getHhgSegments,
    getVendors,
    getVendorContacts,
    getFamilyMembers,
    getFamilyPets,
    postHhgSegment,
    getHhgVehicles,
    showToast,
    getAddress,
    getFinanceAndTax,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getEmailTemplateSummaries,
    getClientDetails,
    setClientId
  })
)(HouseholdGoodsView);
